import React from 'react';
import { useAuth } from '../../auth/AuthContext';
import HelpQueryView from './HelpQueryView';

const HelpQueryPage: React.FC = () => {
  const { user } = useAuth();

  return (
    <HelpQueryView
      fullName={user?.userName?.trim() || 'Account'}
      email={user?.userEmail?.trim() || ''}
    />
  );
};

export default HelpQueryPage;
